// @flow
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import React, { Component } from 'react';
import _ from 'lodash';
import { Form, Grid } from 'semantic-grab-ui/src';
import FormInputWithError from 'omega-rtc/components/form/FormInputWithError';

type Props = {
  model: TridentCampaignDetails,
  inputFields: Array,
  handleInputChange: Function,
  handleControlBlur: Function,
};

class MetadataForm extends Component {
  props: Props;


  render() {
    const { model, handleControlBlur, inputFields } = this.props;
    return (
      <React.Fragment>
        <Grid>
          <h4>Campaign Metadata </h4>
        </Grid>
        <Grid>
          {inputFields.map((inputField) => {
            const key = `metadata.${inputField.payloadPath}`;
            return (<Grid.Column width={6}>
              <FormInputWithError
                name={key}
                {...this.props}
              >
                <Form.Input
                  label={inputField.label}
                  required={inputField.isRequired}
                  value={_.get(model, key)}
                  onChange={this.props.handleInputChange}
                  onBlur={handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>);
          })}
        </Grid>
      </React.Fragment>
    );
  }
}

export default MetadataForm;
